import { AccountingItemType } from '~/types/api/accounting-integration';
export const filterServiceOnlyTemplates = (accountingItems)=>{
    return accountingItems.filter((item)=>item.type === AccountingItemType.Service);
};
